<template>
    <div class="diagram">
        <div class="diagram-page diagram-edit">
            <!-- 1. 顶部标题部分 -->
            <div class="diagram-d-title-bar diagram-edit-title-bar dsp-flex">
                <div class="title-side title-left" @click="clickBack">
                    <span class="title-back"><i class="iconfont icon-xiangzuo"></i></span>
                </div>
                <div class="title-middle">天时六爻</div>
                <div class="title-side title-right" @click="clickSave">
                    <span class="title-save" :class="{'title-gray': !this.formDataEdited && !this.diagramTypeDataChanged}">保存</span>
                </div>
            </div>
            <!-- 2. 编辑页主要内容部分 -->
            <div class="diagram-edit-content width90p">
                <diagram-form v-bind:parentNode="parentNode"></diagram-form>
            </div>
            <div v-if="diagramData && diagramData.f_type != 1" class="diagram-edit-content width90p">
                <div v-if="diagramData.f_type == 2" class="diagram-content-box diagram-hand-box">
                    <div class="diagram-content-title">卦象修改</div>
                    <diagram-hand-list v-bind:parentNode="parentNode"></diagram-hand-list>
                </div>

                <div v-else-if="diagramData.f_type == 3" class="diagram-content-box diagram-hand-box">
                    <div class="diagram-content-title">卦象修改</div>
                    <diagram-choose-diagram v-bind:parentNode="parentNode"></diagram-choose-diagram>
                </div>

                <div v-else-if="diagramData.f_type == 4 || diagramData.f_type == 5" class="diagram-content-box diagram-hand-box">
                    <div class="diagram-content-title">卦象修改</div>
                    <diagram-choose-number v-bind:parentNode="parentNode" :numberLen="3"></diagram-choose-number>
                </div>

                <div v-else-if="diagramData.f_type == 6" class="diagram-content-box diagram-hand-box">
                    <div class="diagram-content-title">卦象修改</div>
                    <diagram-choose-number v-bind:parentNode="parentNode" :numberLen="4"></diagram-choose-number>
                </div>

                <div v-else-if="diagramData.f_type == 7" class="diagram-content-box diagram-hand-box">
                    <div class="diagram-content-title">卦象修改<span v-if="curChoosedCoper == 7" class="diagram-choose-copper-edit" @click="resetChoosedCoper"><span>重新摇卦</span></span></div>
                    <diagram-choose-copper v-bind:parentNode="parentNode"></diagram-choose-copper>
                </div>

            </div>

            <!-- 子路由 -->
            <router-view></router-view>
            <!-- 选择时间弹框 -->
            <van-popup v-bind:value="showTimePanel" position="bottom" @click-overlay="clickShowTimePanelOverlay">
                <input-birthday-panel v-bind:parentNode="parentNode"></input-birthday-panel>
            </van-popup>
            <!-- 手工指定爻弹框 -->
            <van-popup :value="showChooseLine" position="bottom" @click-overlay="clickLineCancel">
                <diagram-choose-line></diagram-choose-line>
            </van-popup>
        </div>
    </div>
</template>

<script>
import DiagramForm from '../../layouts/diagram/DiagramForm.vue';
import DiagramHandList from '../../layouts/diagram/DiagramHandList.vue';
import DiagramChooseLine from '../../layouts/diagram/DiagramChooseLine.vue';
import DiagramChooseDiagram from '../../layouts/diagram/DiagramChooseDiagram.vue';
import DiagramChooseNumber from '../../layouts/diagram/DiagramChooseNumber.vue';
import DiagramChooseCopper from '../../layouts/diagram/DiagramChooseCopper.vue';
import InputBirthdayPanel from '../../components/InputBirthdayPanel.vue'
export default {
    name: 'DiagramEdit',
    components: { DiagramForm, DiagramHandList, DiagramChooseLine, DiagramChooseDiagram, DiagramChooseNumber, DiagramChooseCopper, InputBirthdayPanel },
    computed: {
        diagramData() {
            return this.$store.state.diagram.diagramData;
        },
        formData() {
            return this.$store.state.diagram.formData;
        },
        formDataEdited() {
            return this.$store.state.diagram.formDataEdited;
        },
        curDiagramInputNumber() {
            return this.$store.state.diagram.curDiagramInputNumber;
        },
        curChoosedCoper() {
            return this.$store.state.diagram.curChoosedCoper;
        },
        diagramTypeDataChanged() {
            return this.$store.state.diagram.diagramTypeDataChanged;
        },
        showTimePanel() {
            return this.$store.state.diagram.showTimePanel;
        },
        showChooseLine() {
            return this.$store.state.diagram.showChooseLine;
        },
    },
    data() {
        return {
            parentNode: {'name': 'DiagramEdit'},
        }
    },
    mounted() {
        if(this.diagramData == null) {
            this.$router.replace('/diagramrecord');
        }else {
            setTimeout(() => {
                this.$store.dispatch('initTimeInputData', {time: this.diagramData.f_time, from: 'diagram'})
            }, 20);
        }
        
    },
    methods: {
        goBack() {
            let fullPath = this.$router.history.current.fullPath;
                fullPath = fullPath.replace('/diagramedit', '/diagramdetail');
            this.$router.replace(fullPath);
        },
        clickBack() {
            if(this.formDataEdited || this.diagramTypeDataChanged) {
                this.$dialog.confirm({
                    message: '是否要保存修改？',
                    confirmButtonText: '保存',
                    cancelButtonText: '不保存'
                }).then(() => {
                    // 触发保存
                    this.saveDiagram();
                }).catch(() => {
                    // 返回上一页
                    this.goBack();
                });
            }else {
                this.goBack();
            }
        },
        clickSave() {
            if(!this.formDataEdited && !this.diagramTypeDataChanged) {
                return;
            }
            if(this.diagramTypeDataChanged) {
                if(this.diagramData.f_type == 4 || this.diagramData.f_type == 5 || this.diagramData.f_type == 6) {
                    if(this.curDiagramInputNumber == '') {
                        this.$toast("请完成数字输入再起卦");
                        return;
                    }
                }
                // 卦信息有修改的时候要判断输入信息是否完整
                if(this.diagramData.f_type == 7 && this.curChoosedCoper <= 6) {
                    this.$toast("请摇出六爻再保存");
                    return;
                }
            }
            this.saveDiagram();
        },
        saveDiagram() {
            this.$store.dispatch('diagram/saveDiagramEdit', {
                type: 'base',
                sucCb: () => {
                    this.goBack();
                }
            })
        },
        clickShowTimePanelOverlay() {
            this.$store.state.diagram.showTimePanel = false;
        },
        clickLineCancel() {
            this.$store.state.diagram.showChooseLine = false;
        },
        resetChoosedCoper() {
            this.$store.dispatch('diagram/resetDiagramChoosedCoper');
        }
    }
}
</script>